(function() {
	const $ = s => document.querySelector(s);
	
	const shCont = $('.sh');
	const shTog = $('.sh-toggle');
	const shCls = $('.sh-close');
	const shOvr = $('.sh-over');
	const shNav = $('.sh-nav');

	if(!shCont) return;

	let openItm = null;
	let cTmt = null;
	let rTmr = null;

	const isMob = () => window.innerWidth <= 1200;

	const opn = (i) => {
		if(openItm === i) return;

		cls();
		openItm = i;
		i.classList.add('is-open');

		/* Mobilní drawer: otevřené podmenu = druhý panel, 1. úroveň odjíždí (sh-subview). */
		if(isMob() && shNav && i.querySelector('[data-menu]')) {
			shNav.classList.add('sh-subview');
		}

		if(i.hasAttribute('data-mega')) {
			shCont.classList.add('mega-open');
		}

		const trigger = i.querySelector('[data-trig]');
		if(trigger) {
			trigger.setAttribute('aria-expanded', 'true');
		}
	};

	const cls = () => {
		if(shNav) shNav.classList.remove('sh-subview');
		if(!openItm) return;

		openItm.classList.remove('is-open');
		shCont.classList.remove('mega-open');

		const trigger = openItm.querySelector('[data-trig]');
		if(trigger) {
			trigger.setAttribute('aria-expanded', 'false');
		}

		openItm = null;
	};

	const schCls = () => {
		clearTimeout(cTmt);
		cTmt = setTimeout(cls, 120);
	};

	const canCls = () => {
		clearTimeout(cTmt);
	};

	shCont.addEventListener('mouseover', e => {
		if(isMob()) return;

		const i = e.target.closest('[data-sub]');
		if(i) {
			canCls();
			opn(i);
			return;
		}

		if(e.target.closest('.sh-item:not([data-sub])')) {
			canCls();
			cls();
		}

		if(e.target.closest('[data-menu]')) {
			canCls();
		}
	});

	shCont.addEventListener('mouseleave', () => {
		if(!isMob()) {
			schCls();
		}
	});

	const hTouchClick = (e, isT) => {
		const trg = e.target.closest('[data-trig]');
		if(!trg) return;

		const i = trg.closest('[data-sub]');

		if(isT) {
			if(i && i !== openItm) {
				e.preventDefault();
				opn(i);
			} else if(i === openItm && isMob()) {
				e.preventDefault();
				cls();
			}
		} else if(isMob()) {
			e.preventDefault();
			openItm === i ? cls() : opn(i);
		}
	};

	shCont.addEventListener('touchstart', e => hTouchClick(e, true), { passive: false });

	document.addEventListener('click', e => {
		if(!isMob() && openItm && !openItm.contains(e.target)) {
			cls();
		} else if(isMob()) {
			hTouchClick(e, false);
		}
	});

	document.addEventListener('keydown', e => {
		if(e.key === 'Escape') {
			cls();
			if(shCont.classList.contains('sh-open')) {
				clsFull();
			}
		}
	});

	const clsFull = () => {
		shCont.classList.remove('sh-open');
		/* Reset na 1. úroveň — po znovuotevření drawer nezačíná v podmenu. */
		cls();
		if(shTog) {
			shTog.setAttribute('aria-expanded', 'false');
		}
	};

	/* Šipka zpět v hlavičce podmenu (mobilní drawer). */
	shCont.addEventListener('click', e => {
		const back = e.target.closest('[data-back]');
		if(back) {
			e.preventDefault();
			e.stopPropagation();
			cls();
		}
	});

	if(shTog) {
		shTog.addEventListener('click', e => {
			e.preventDefault();
			shCont.classList.add('sh-open');
			shTog.setAttribute('aria-expanded', 'true');
		});
	}

	if(shCls) {
		shCls.addEventListener('click', e => {
			e.preventDefault();
			clsFull();
		});
	}

	if(shOvr) {
		shOvr.addEventListener('click', clsFull);
	}

	window.addEventListener('resize', () => {
		shCont.classList.add('sh-resize');
		clearTimeout(rTmr);

		rTmr = setTimeout(() => {
			shCont.classList.remove('sh-resize');
		}, 150);

		if(!isMob() && shCont.classList.contains('sh-open')) {
			clsFull();
			cls();
		}
	});
})();